import React, { Component } from 'react';
import styled from 'styled-components';

import sharePriceIcon from '../../assets/share-icon.svg';
import { white, brandBlue10 } from '../../styles/styleVariables';
import stockUrl from '../../api/stockApi';

const SharePriceWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -3rem;
  width: 100%;
`;

const SharePriceTitle = styled.p`
  color: ${brandBlue10};
  font-size: 0.9rem;
  margin: 0 0 0.5rem 0;
`;

const SharePriceData = styled.p`
  margin: 0;
  font: 1.3rem 'AmcorPro SemiBold', sans-serif;
`;

const SharePriceTitleWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  color: ${white};
  height: 4rem;
  background: url(${sharePriceIcon}) no-repeat left center;
  background-size: 2.5rem;
  padding-left: 3.2rem;
  width: 7.6rem;
`;

class SharePrice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sharePrice: '',
    };
  }
  componentDidMount() {
    fetch(stockUrl)
      .then(response => response.json())
      .then((response) => {
        const sharePrice = response.data[0].lastPrice;
        this.setState({ sharePrice });
      })
      .catch((error) => {
        console.log('in fetchSharePrice error: ', error);
      });
  }
  render() {
    if (!this.state.sharePrice) return null; // ToDo Loader - Change for a loader
    return (
      <SharePriceWrapper>
        <SharePriceTitleWrapper>
          <SharePriceTitle>Share price</SharePriceTitle>
          <SharePriceData>{ this.state.sharePrice }</SharePriceData>
        </SharePriceTitleWrapper>
      </SharePriceWrapper>
    );
  }
}

export default SharePrice;



// WEBPACK FOOTER //
// ./src/containers/SharePrice/index.js